import { INCREASE_FONT_SIZE, DECREASE_FONT_SIZE } from 'constants/actionTypes'
import { FONTSIZE } from 'constants/fontSize'
import { Action } from 'actions'

const initialState = FONTSIZE.SMALL

const fontSizeManager = (state = initialState, action: Action) => {
  switch (action.type) {
    case INCREASE_FONT_SIZE: {
      return FONTSIZE.LARGE
    }
    case DECREASE_FONT_SIZE: {
      return FONTSIZE.SMALL
    }
    default: {
      return state
    }
  }
}

export default fontSizeManager
